
















































import { Popup, Button } from '@hb/coffee';
import {
  defineComponent, computed,
  PropType, onMounted,
} from '@vue/composition-api';
import {
  RightPackageTypeEnum, RightSummaryType, LoanCardTypeEnum,
} from '@/api/rights/types';
import { ubtSetupPageButton, ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { ActionTypeEnum } from './popupAService';

export default defineComponent({
  name: 'PopStyleA',
  components: {
    Popup,
    Button,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    rightParams: {
      type: Object as PropType<RightSummaryType>,
      required: true,
    },
  },
  setup(props: {
    modelValue: boolean;
    rightParams: RightSummaryType;
  }, { emit }: {
    emit: (event: string, ...args: unknown[]) => void;
  }) {
    /** 是否展示popup */
    const showPopup = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    const handleSelect = () => {
      // 点击选择特权埋点
      ubtSetupPageButton('finance_loan_rightCallback_enjoyRight', {
        ...props.rightParams,
        buttonName: ActionTypeEnum.AGREE,
      });
      emit('choose', true, ActionTypeEnum.AGREE);
    };

    const handleGiveUp = () => {
      // 点击放弃特权埋点
      ubtSetupPageButton('finance_loan_rightCallback_giveUpRight', {
        ...props.rightParams,
        buttonName: ActionTypeEnum.REJECT,
      });
      emit('choose', false, ActionTypeEnum.REJECT);
    };

    const isHaXiangCard = computed(() => {
      const { packageType, loanCardType } = props.rightParams;
      return packageType === RightPackageTypeEnum.CHANNEL_B
        && (loanCardType === LoanCardTypeEnum.YOU_SU_CARD
        || loanCardType === LoanCardTypeEnum.CHANNEL_RIGHT);
    });

    onMounted(() => {
      // 曝光埋点
      ubtSetupModuleExpose('finance_loan_rightCallback', {
        ...props.rightParams,
      });
    });
    return {
      isHaXiangCard,
      handleSelect,
      handleGiveUp,
      showPopup,
    };
  },
});
